import bonusIslandImg from '../../../../assets/images/bonus-island/bonus-img.png';

const BonusIslandButton = ({ onClick }) => {
  return (
    <button className='bonus-island-btn-mob' onClick={onClick}>
      <img src={bonusIslandImg} alt='' />
    </button>
  );
};

export default BonusIslandButton;
